import { HashRouter, Routes } from '@/router/HashRouter';
import { renderHeader, renderFooter } from '@/components/Layout';
import { CalculatorView } from '@/views/CalculatorView';
import { LegendView } from '@/views/LegendView';
import { SettingsView } from '@/views/SettingsView';
import { EmailGateModal } from '@/components/EmailGateModal';
import { EmailService } from '@/services/EmailService';
import { StorageService } from '@/services/StorageService';
import { HotelParams } from '@/models/HotelParams';
import { faL } from '@fortawesome/free-solid-svg-icons';

/**
 * Controller applicativo: gestisce il ciclo di vita delle viste,
 * il routing, l'email gate e la propagazione delle modifiche ai parametri.
 */
export class AppController {
  private router: HashRouter;
  private currentRoute: Routes = Routes.EMPTY;

  // Vista correntemente montata (per pulizia futura se serve)
  private calcView?: CalculatorView;

  constructor() {
    this.router = new HashRouter();
  }

  isWp: boolean = false;
  start(): void {
    const subHeader = document.querySelector('.ast-below-header-wrap')
    if (subHeader) {
      console.log('wordpress detected!')
      this.isWp = true;
      const aboveFooter = document.querySelector('.site-above-footer-wrap');
      if (aboveFooter)
        aboveFooter.remove();
      subHeader.remove();
      const siteContainer = document.querySelector('.site-content')! as HTMLDivElement
      siteContainer.classList.add('bg-slate-50');

    }

    renderFooter();
    this.router.subscribe((route) => this.handleRoute(route));
    // Primo render esplicito (utile se DOMContentLoaded è già scoccato)
    this.handleRoute(this.router.current());
  }

  private handleRoute(route: Routes): void {
    if (route === this.currentRoute) return;
    this.currentRoute = route;

    // Email gate per la pagina Impostazioni
    if (route === Routes.SETTINGS && !EmailService.get()) {
      this.gateSettings();
      return;
    }

    renderHeader(this.router, route);

    const root = document.getElementById('app-root');
    if (!root) return;
    root.innerHTML = '';
    window.scrollTo({ top: 0, behavior: 'smooth' });

    switch (route) {
      case 'calculator':
        this.calcView = new CalculatorView({
          params: StorageService.load(),
          onParamsChange: (p: HotelParams) => {
            // eslint-disable-next-line no-console
            console.debug('[params]', p);
          },
        });
        this.calcView.mount(root);
        break;
      case 'legend':
        new LegendView().mount(root);
        break;
      case 'settings':
        // DISABLED
        // new SettingsView({
        //   onParamsChange: () => {
        //     // Settings modifica i parametri direttamente in localStorage;
        //     // la CalculatorView legge dallo storage al montaggio.
        //   },
        // }).mount(root);
        // break;
      default:
        this.router.navigate(HashRouter.DEFAULT_ROUTE);
        return;
    }

    // annuncio ARIA
    const live = document.getElementById('aria-live');
    if (live) live.textContent = `Pagina ${route} caricata`;
  }

  /**
   * Mostra la modale di acquisizione email; se l'utente inserisce
   * un'email valida, accede alla pagina Impostazioni. Altrimenti
   * viene rimandato al calcolatore.
   */
  private gateSettings(): void {
    new EmailGateModal({
      message: 'Per accedere alle impostazioni e scaricare i dati (CSV/Excel), inserisci la tua email. I dati restano sul tuo dispositivo.',
      onSuccess: () => {
        // Email salvata: procedi alla pagina Impostazioni
        this.currentRoute = Routes.EMPTY; // forza il re-render
        this.handleRoute(Routes.SETTINGS);
      },
      onCancel: () => {
        // Annullato: torna al calcolatore
        this.router.navigate(Routes.CALCULATOR);
      },
    }).open();
  }
}
